import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _noop from 'lodash/noop';

import DropdownPattern from '@mlb/react-patterns/components/Dropdown/dropdown.tsx';

import { useDictionary } from 'bdvp-common/src/hooks/config';
import { Tracking } from 'bdvp-tracking';

const Dropdown = styled(DropdownPattern)`
    margin-left: 22px;
    z-index: 3;
`;

const SortDropdown = ({
    options,
    selected,
    applySearchSort,
}) => {

    const dictionary = useDictionary();

    return (
        <Dropdown
            options={options}
            selected={selected}
            placeholder={dictionary.sort_by ?? 'Sort By'}
            width={'160px'}
            handlers={
                {
                    onChange: ({ selected: updatedSelected }) => {

                        const updatedSearchSort = updatedSelected?.value;

                        if(selected?.value === updatedSearchSort) {

                            return;

                        }

                        Tracking.trackSortSelect(updatedSelected?.label);
                        applySearchSort(updatedSearchSort);

                    },
                }
            }
        />
    );

};

SortDropdown.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
        })
    ).isRequired,
    selected: PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
    }),
    applySearchSort: PropTypes.func,
};

SortDropdown.defaultProps = {
    selected: null,
    applySearchSort: _noop,
};

export default SortDropdown;
